import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
	'loading_screen' : {
        'name': 'Loading Screen',
        'description': 'Using eye-catching animations to enhance user experience while they wait for pages to load.',
        'start_description': 'Using eye-catching animations to enhance user experience while they wait for pages to load.<br>This technique used by Facebook, Youtube, Ebay',
        'simple_1': 'Simple',
        'simple_2': 'Prestige',
        'simple_3': 'Boundless',
        'simple_4': 'Minimal',
        'select_template': 'Select template',
        'background_settings': 'Background settings',
        'solid_color': 'Solid color',
        'custom_background': 'Custom background',
        'hidden': 'Hidden',
        'components_text': 'Components',
        'reset_value': 'Reset to default',
        'select_theme_above': 'Select theme above to edit the components',
        'choose_template': '- Choose template -',
        'watch_example': 'You can watch examples again here',
        'components': {
            'watch_demo': 'Watch demo video',
            'example_videos': 'Example videos',
            'watch_how': 'Watch how Facebook, Youtube, and Ebay use it',
            'start_title_available': 'Customize your own loading screen',
            'start_title_unavailable': 'Customize your own loading screen with Premium Plan',
            'demo_from': 'Demo from',
            'start_description_available': 'Create loading screen with your own logo and eye-catching animations.',
            'start_description_unavailable': 'Loading Screen is not available in your current plan, upgrade now to get it!'
        },
        'buttons': {
            'custom_screen': 'Custom now',
            'watch_example_videos': 'Watch example videos',
            'i_got_it': 'I got it',
            'customize_now': 'Customize now'
        },
        'settings': {
           'loading_effect' : 'Loading Time',
           'delay_time': 'Delay time',
           'duration_time': 'Duration time',
           'delay_description': 'How long a loading screen takes to close',
           'duration_description': 'How long a loading screen takes to complete',
           'display': 'Display',
           'when_to_show': 'When to show',
           'first_visit': 'First visit',
           'every_visit': 'Every visit',
           'page_to_show': 'Page to show',
           'every_page': 'Every page',
           'specific_page': 'Specific page'
        },
        'pages': {
            'home': 'Homepage',
            'collection': 'Collection page',
            'blog': 'Blog page',
            'product': 'Product page',
            'online_store': 'Online store page'
        },
        'start': {
            'title': 'Make every second value',
            'description': 'Loading screen help your page decrease 60% user drop while waiting.'
        },
        'confirm': {
            'reset_data': 'Template <strong>{template_name}</strong> will return to the default setting. Are you sure to reset?',
            'reset_sucessfully': 'Reset successfully'
        },
        'errors': {
            'upload_image': 'Please select image to save',
            'select_page': 'Please select page to save',
            'select_template': 'Please select a template to save'
        }
	}
})